<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <edit-form ref="edit-form" header-color="green"> </edit-form>
    </div>
  </div>
</template>
<script>
import EditForm from "./SeasonUpdateComponent/SeasonEditForm";

export default {
  components: {
    EditForm
  },
  mounted() {
    this.seasonID = this.$route.params.id;
    this.$store.getSeason(this.seasonID).then(response => {
      this.$refs["edit-form"].name = response.data.name;
      this.$refs["edit-form"].period = response.data.period;
      // Status
      if (response.data.status === "Full Active") {
        this.$refs["edit-form"].status = 1;
      } else if (response.data.status === "Active") {
        this.$refs["edit-form"].status = 2;
      } else if (response.data.status === "Inactive") {
        this.$refs["edit-form"].status = 3;
      }
    });
  }
};
</script>
